/**
 * Clear Sparro-specific browser storage on sign-out to reduce leftover PII on shared devices.
 * Does not clear Firebase Auth persistence (handled by signOut).
 */
export function clearSparroBrowserStorage(uid) {
  if (typeof window === "undefined") return;
  try {
    const toRemove = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith("sparro_")) toRemove.push(k);
    }
    toRemove.forEach((k) => window.localStorage.removeItem(k));
  } catch {
    // ignore
  }
  try {
    if (uid && window.sessionStorage) {
      window.sessionStorage.removeItem(`sparro_login_audit_${uid}`);
    }
  } catch {
    // ignore
  }
}
